// Dashboard HRIS (brief owner 15 Sep 2026, G8 — UJI COBA, lihat BACA-DULU-G8.md).
//
// Isinya PERSIS seksi "Tenaga Kerja & Payroll" + kartu "Absensi Minggu Ini vs
// Minggu Lalu" yang dulu ada di halaman depan — DIPINDAH, bukan dibuat ulang:
// komponennya diimpor dari pages/Dashboard.jsx dan datanya dari `GET /dashboard`
// dengan query key yang SAMA (`DASHBOARD_QK`). Akibatnya gerbangnya identik
// dengan sebelum dipindah (`dashboard.view` + pilihan widget per pengguna), dan
// berpindah antar dua dashboard tidak memuat ulang data.
import { EyeOff, Users } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useDataQuery } from "@/hooks/useDataQuery";
import LoadingState from "@/components/ui/loading-state";
import { DASHBOARD_QK, SeksiHris, AttendanceWowCard } from "./Dashboard";
import { WIDGET_HRIS_ABSENSI, WIDGET_HRIS_RINGKASAN } from "../lib/halamanAwal";

export default function HrisDashboard() {
  const { canWidget } = useAuth();
  const { data, error, refetch } = useDataQuery(DASHBOARD_QK, () => api.get("/dashboard").then((r) => r.data));
  // Syarat yang SAMA dengan yang dulu merender kedua seksi ini di halaman depan. Daftar
  // widgetnya dari lib halaman awal (G8 butir b): aturan itu hanya mengarahkan orang ke
  // sini kalau salah satu widget ini aktif — kalau daftarnya diketik ulang di sini dan
  // berpisah jalan, orang dialihkan ke Dashboard HRIS yang isinya kosong.
  const showHris = WIDGET_HRIS_RINGKASAN.some((k) => canWidget(k));
  const showAbsensi = canWidget(WIDGET_HRIS_ABSENSI);

  return (
    <div className="p-4 md:p-8 max-w-[1400px]" data-testid="hris-dashboard">
      <header className="mb-6 md:mb-8">
        <p className="text-xs font-semibold uppercase tracking-wider text-emerald-600 mb-2 inline-flex items-center gap-1.5">
          <Users className="w-3.5 h-3.5" /> HRIS
        </p>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-900">Dashboard HRIS</h1>
        <p className="mt-2 text-xs md:text-sm text-slate-500">Ringkasan tenaga kerja, estimasi payroll tetap, dan absensi minggu ini.</p>
      </header>
      {!data ? (
        <LoadingState loading={!error} error={error} onRetry={refetch} data-testid="hris-dashboard-status" />
      ) : (
        <>
          {!showHris && !(showAbsensi && data.wow?.attendance) && (
            <div className="bg-white border border-slate-200 rounded-xl p-8 text-center" data-testid="hris-dashboard-kosong">
              <div className="w-12 h-12 mx-auto rounded-full bg-slate-100 grid place-items-center text-slate-400 mb-3">
                <EyeOff className="w-6 h-6" />
              </div>
              <h3 className="font-display text-base font-bold text-slate-900 mb-1">Belum ada widget HRIS yang diaktifkan</h3>
              <p className="text-sm text-slate-500">Superadmin dapat mengaktifkannya lewat <b>User Management</b> → <b>Atur Izin</b>.</p>
            </div>
          )}
          {showAbsensi && data.wow?.attendance && <AttendanceWowCard att={data.wow.attendance} />}
          {showHris && <SeksiHris data={data} canWidget={canWidget} />}
        </>
      )}
    </div>
  );
}
